import React from "react";
import { API_TECHNOLOGIES, HandleApi } from "../contants/general.constants";
import { Card } from "./card/card";

import apacheLogo from "../assests/images/logos/apache_logo.png";
import jsLogo from "../assests/images/logos/js_logo.png";
import postgresqlLogo from "../assests/images/logos/postgresql_logo.png";
import pythonLogo from "../assests/images/logos/python_logo.png";

const FALLBACK_TECHNOLOGIES = [
 { name: "Python", icon: pythonLogo },
 { name: "JavaScript", icon: jsLogo },
 { name: "PostgreSQL", icon: postgresqlLogo },
 { name: "Apache", icon: apacheLogo },
];

export function TechnologiesComponent() {
 const [technologies, setTechnologies] = React.useState(null);

 HandleApi(API_TECHNOLOGIES, setTechnologies, setTechnologies);

 const cardContent = {
  header: "Technologies",
  description: "The tools we use to forge — battle-tested, modern, and chosen to fit the job.",
  key: "technologies",
  content: [],
 };

 if (technologies) {
  const results = technologies.results.filter((technology) => technology.name);
  cardContent.content = results.length
   ? results.map((technology) => ({ name: technology.name, icon: technology.image }))
   : FALLBACK_TECHNOLOGIES;
 }

 return <Card key="technologies" props={{ card: cardContent, id: "technologies" }} />;
}
